'use strict';

// Settings configured here will be merged into the final config object.
export default {
    baseUrlPath: '/_html5/',
    checkDomainServiceUrl: 'https://41jnr1e5h0.execute-api.eu-west-1.amazonaws.com',
    okIPList: [],
    goodIPList: ["93.184.220.23","72.21.91.23","68.232.44.23","85.233.160.101"],
    cnameList: ["cdn.sitemakerlive.com"],
    hostnameBaseURL: '', // Change your dev.js to point at your dev.vm, ex http://qwerty.lazevedo.dev if your dev.vm supports CORS
    uploadBaseURL: '',  // Change your dev.js to point at your dev.vm, ex http://lazevedo.dev if your dev.vm supports CORS

    //Google font api
    googleFontApiKey: "AIzaSyBtpFxSlxixYvucPjAkiOeWWYyhi2oROlo",
    googleFontApiUrl: "https://www.googleapis.com/webfonts/v1/webfonts",


    // Feature flips
    enableToSwitchRevisions: false,  // Enable page revision switcher in the UI
    enableLogging:false,             // Enable logging (mainly for redux middleware)
    enableDevSidebarPanel: false,    // Enable Dev Features in the Sidebar
    enableToolbarSaveButton: false,  // Toolbar save button, disable for production
    enableSidebarEditorTab: false,   // Extra tab on the side bar to configure editor features
}



// WEBPACK FOOTER //
// ./src/config/base.js